import React from 'react';
import { BellIcon, HomeIcon, PawPrintIcon, FileTextIcon, CreditCardIcon, AlertTriangleIcon, BarChart3Icon, SearchIcon } from 'lucide-react';
import { SOLUTION_IMAGES, solutionCopy, adminNav, adminCopy, animalRecords, type Bi } from '../../data/animalsSolution';
type P = {
  isFR: boolean;
};
const pk = (isFR: boolean) => (v: Bi) => isFR ? v.fr : v.en;
// Exact logo files used in the site header (components/Header.tsx)
const BCITI_LOGO = 'https://cdn.magicpatterns.com/uploads/kFQruRR3oauw7NNUdgFajn/Logo_BCITI_(5).png';
const ATNA_LOGO = 'https://cdn.magicpatterns.com/uploads/d6cqpG2SGUofNqC1hEedXv/Logo_ATNA_(5).png';
export function ReminderCard({
  isFR
}: P) {
  const pick = pk(isFR);
  return <div className="rounded-[24px] border border-[#ECECF4] bg-white shadow-[0_24px_50px_-30px_rgba(40,36,120,0.5)] p-5 flex items-start gap-4" data-id="element-462" data-mp="2daoqzfo3hn8j">
      <span className="w-14 h-14 rounded-full bg-[#4F46E5] flex items-center justify-center shrink-0 ring-4 ring-[#EEEDFD]" aria-hidden="true" data-id="element-463" data-mp="299v4mqqawghr">
        <BellIcon className="w-6 h-6 text-white" strokeWidth={1.8} data-id="element-464" data-mp="2taycfo5p3ky8" />
      </span>
      <div className="min-w-0" data-id="element-465" data-mp="2y1n9dj059a4r">
        <p className="font-sans text-[17px] font-semibold text-[#121A3A]" data-id="element-466" data-mp="2y2ovciip7h19">{pick(solutionCopy.reminderTitle)}</p>
        <p className="font-sans text-[14.5px] text-[#5B6478] leading-snug mt-1" data-id="element-467" data-mp="2kc39qm1v0szo">{pick(solutionCopy.reminderBody)}</p>
      </div>
    </div>;
}
const NAV_ICONS = {
  dashboard: HomeIcon,
  animals: PawPrintIcon,
  licences: FileTextIcon,
  payments: CreditCardIcon,
  reminders: BellIcon,
  reports: AlertTriangleIcon,
  analytics: BarChart3Icon
} as const;
export function AdminRegister({
  isFR
}: P) {
  const pick = pk(isFR);
  return <div className="rounded-[18px] bg-[#1B1D26] p-[8px] shadow-[0_40px_70px_-36px_rgba(20,20,60,0.7)]" data-id="element-468" data-mp="3802xdd3vk3a1">
      <div className="rounded-[12px] bg-white overflow-hidden" data-id="element-469" data-mp="1rm4fmc8t65o5">
        <div className="flex items-center gap-2 px-4 py-3 border-b border-[#F0F0F6]" data-id="element-470" data-mp="1rkjn0s620wsx">
          <img src={BCITI_LOGO} alt="BCITI" className="h-6 w-auto object-contain" data-id="element-471" data-mp="1wmio1vebnhmp" />
          <span className="text-[#121212]/25 font-sans text-sm font-light select-none" aria-hidden="true" data-id="element-472" data-mp="23e8yz9bhrqr">|</span>
          <img src={ATNA_LOGO} alt="ATNA" className="h-5 w-auto object-contain" data-id="element-473" data-mp="3tbk16rg6zgum" />
        </div>
        <div className="flex" data-id="element-474" data-mp="3oiqwg3kq48ij">
          <ul className="hidden sm:block w-[150px] shrink-0 border-r border-[#F2F2F7] p-2 space-y-0.5" data-id="element-475" data-mp="3ohxoiza13cyt">
            {adminNav.map(n => {
            const Icon = NAV_ICONS[n.key];
            const active = n.key === 'animals';
            return <li key={n.key} className={`flex items-center gap-2 rounded-lg px-2.5 py-2 font-sans text-[11.5px] ${active ? 'bg-[#EEEDFD] text-[#4F46E5] font-semibold' : 'text-[#3A4258]'}`} data-id="element-476" data-mp="3ajrax4sic9ql">
                  <Icon className={`w-3.5 h-3.5 shrink-0 ${active ? 'text-[#4F46E5]' : 'text-[#8A90A2]'}`} strokeWidth={1.8} aria-hidden="true" data-id="element-477" data-mp="13t1l40j8b4ul" />
                  <span className="whitespace-nowrap" data-id="element-478" data-mp="zqn0baw01v0o">{pick(n.label)}</span>
                </li>;
          })}
          </ul>
          <div className="flex-1 min-w-0 p-3.5" data-id="element-479" data-mp="2moe38msxefgs">
            <p className="font-sans text-[16px] font-semibold text-[#121A3A]" data-id="element-480" data-mp="2mn2zgmzhd7po">{pick(adminCopy.title)}</p>
            <div className="mt-2.5 flex items-center gap-2 rounded-lg border border-[#ECECF4] px-2.5 py-2" data-id="element-481" data-mp="2ri0goh6wyndn">
              <SearchIcon className="w-3.5 h-3.5 text-[#8A90A2] shrink-0" aria-hidden="true" data-id="element-482" data-mp="2vjbyw1ngk6bt" />
              <span className="font-sans text-[11px] text-[#8A90A2] truncate" data-id="element-483" data-mp="1ytl4e2f62j60">{pick(adminCopy.search)}</span>
            </div>
            <ul className="mt-2.5 divide-y divide-[#F0F0F6]" data-id="element-484" data-mp="27rezxb53x8s4">
              {animalRecords.map(r => <li key={r.name} className="flex items-center gap-2.5 py-2.5" data-id="element-485" data-mp="2crj90g3or18b">
                  <img src={SOLUTION_IMAGES[r.image]} alt="" className="w-9 h-9 rounded-full object-cover shrink-0" data-id="element-486" data-mp="3j73kjvuw1vpr" />
                  <span className="flex-1 min-w-0" data-id="element-487" data-mp="3o5n7nzl7xdjp">
                    <span className="block font-sans text-[12.5px] font-semibold text-[#121A3A]" data-id="element-488" data-mp="3o89ic83eo965">{r.name}</span>
                    <span className="block font-sans text-[10.5px] text-[#8A90A2] truncate" data-id="element-489" data-mp="3mqubczz1pvf5">{pick(r.kind)}</span>
                  </span>
                  <span className={`rounded-full px-2 py-0.5 font-sans text-[10px] font-semibold whitespace-nowrap ${r.status === 'active' ? 'bg-[#22A04F] text-white' : 'bg-[#F6B545] text-white'}`} data-id="element-490" data-mp="3vpxw08dv2ivr">
                    {r.status === 'active' ? pick(adminCopy.active) : pick(adminCopy.expiring)}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>;
}